import { render } from "./AllsectionImages.vue?vue&type=template&id=525f9a22&scoped=true"
import script from "./AllsectionImages.vue?vue&type=script&lang=js"
export * from "./AllsectionImages.vue?vue&type=script&lang=js"

import "./AllsectionImages.vue?vue&type=style&index=0&id=525f9a22&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-525f9a22"]])

export default __exports__